module.exports = __webpack_public_path__ + "_assets/img/home.98d19af0.svg";